export const Ticket = 'Ticket/';

export const TicketSearch = Ticket + 'Search';
export const TicketFeedback = Ticket + 'feedback';
